import { getAuth } from "firebase/auth";
import axios from "axios";
import SettingsResponse from "../models/SettingsResponse";

const BASE_URL =
  "https://europe-west3-hyper-e122e.cloudfunctions.net/get_my_settings";

const ADDITIONAL_SETTINGS_URL =
  "https://europe-west3-hyper-e122e.cloudfunctions.net/get_my_additional_settings";

export const SettingsService = {

  async fetchSettings() {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (!currentUser) {
        throw new Error(
          "Пользователь не авторизован"
        );
      }

      const token =
        await currentUser.getIdToken(true);

      const payload = {
        user_id: currentUser.uid
      };

      const response = await axios.post(
        BASE_URL,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      );

      console.log(
        "✅ Настройки успешно получены:",
        response.data
      );

      const settings =
        new SettingsResponse(response.data);

      localStorage.setItem(
        "favorites_count",
        String(settings.favoritesCount)
      );

      localStorage.setItem(
        "my_vacancies_count",
        String(settings.myVacanciesCount)
      );

      localStorage.setItem(
        "friends_count",
        String(settings.friendsCount)
      );

      localStorage.setItem(
        "requests_count",
        String(settings.requestsCount)
      );

      localStorage.setItem(
        "is_admin",
        settings.isAdmin ? "true" : "false"
      );

      localStorage.setItem(
        "is_employer",
        settings.isEmployer ? "true" : "false"
      );

      localStorage.setItem(
        "ai_policy_accept",
        settings.aiPolicyAccept
          ? "true"
          : "false"
      );

      localStorage.setItem(
        "is_digital_signed",
        settings.isDigitalSigned
          ? "true"
          : "false"
      );

      localStorage.setItem(
        "total_filling_count",
        String(settings.totalFillingCount)
      );

      localStorage.setItem(
        "name",
        settings.name
      );

      localStorage.setItem(
        "specifics",
        settings.specifics
      );

      localStorage.setItem(
        "asr_configuration",
        settings.asrConfiguration
          ? "true"
          : "false"
      );

      localStorage.setItem(
        "is_new_responses",
        settings.isNewResponses
          ? "true"
          : "false"
      );

      console.log(
        "💾 Все настройки сохранены в localStorage"
      );

      return settings;

    } catch (error) {

      console.error(
        "❌ Ошибка SettingsService.fetchSettings:",
        error.response?.data ||
        error.message
      );

      return null;
    }
  },


  
async fetchAdditionalSettings() {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      throw new Error(
        "Пользователь не авторизован"
      );
    }

    const token =
      await currentUser.getIdToken(false);

    // ============================================================
    // REQUEST
    // ============================================================

    const response = await axios.get(
      ADDITIONAL_SETTINGS_URL,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );

    console.log(
      "🔥 RAW ADDITIONAL SETTINGS:",
      response.data
    );

    // ============================================================
    // NEW MESSAGES
    // ============================================================

    const hasNewMessages =
      response.data?.has_new_messages === true;

    // ============================================================
    // PREMIUM STATUS
    // ============================================================

    const isPremiumEnabled =
      response.data?.is_premium_enabled === true;

    // ============================================================
    // RENEW SUBSCRIPTION
    // ============================================================

    const isShowRenewSubscribtions =
      response.data?.is_show_renew_subscribtions === true;

    // ============================================================
    // LOGGING
    // ============================================================

    console.log(
      "✅ Доп. настройки получены:",
      response.data
    );

    console.log(
      "💬 New messages:",
      hasNewMessages
    );

    console.log(
      "💎 Premium enabled:",
      isPremiumEnabled
    );

    console.log(
      "🔔 Show renew subscription:",
      isShowRenewSubscribtions
    );

    // ============================================================
    // LOCAL STORAGE
    // ============================================================

    localStorage.setItem(
      "has_new_messages",
      String(hasNewMessages)
    );

    localStorage.setItem(
      "isPremiumEnabled",
      String(isPremiumEnabled)
    );

    localStorage.setItem(
      "isShowRenewSubscribtions",
      String(isShowRenewSubscribtions)
    );

    // ============================================================
    // NOTIFY OTHER COMPONENTS
    // ============================================================

    window.dispatchEvent(
      new CustomEvent(
        "additional-settings-updated",
        {
          detail: {
            hasNewMessages,
            isPremiumEnabled,
            isShowRenewSubscribtions
          }
        }
      )
    );

    // ============================================================
    // RESULT
    // ============================================================

    return {
      hasNewMessages,
      isPremiumEnabled,
      isShowRenewSubscribtions
    };

  } catch (error) {

    console.error(
      "❌ Ошибка SettingsService.fetchAdditionalSettings:",
      error.response?.data ||
      error.message
    );

    return null;
  }
}

};